<template>
  <div>
    <v-row class="d-flex justify-space-between" flat>
      <v-col md="6" sm="6">
        <h1 class="heading-1">Newsletters</h1>
      </v-col>
    </v-row>
    <!------------------section two------------------------>
    <div class="my-3">
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              hide-details
              single-line
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <!-- <v-card flat>
            <v-select
              dense
              label="Filters"
              single-line
              outlined
              prepend-inner-icon="mdi-tune"
            >
            </v-select>
          </v-card> -->
        </v-col>
      </v-row>
    </div>
    <v-card class="mt-6" outlined>
      <v-data-table
        :search="search"
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :items="GetNewsLetter"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.indexNo`]="{ index }">
          <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }}</b>
        </template>

        <template v-slot:[`item.FirstName`]="{ item }">
          <span class="table_style_one"> {{ item.FirstName }} </span>
        </template>
        <template v-slot:[`item.LastName`]="{ item }">
          <span class="table_style_two"> {{ item.LastName }} </span>
        </template>
        <template v-slot:[`item.Email`]="{ item }">
          <span class="table_style_two"> {{ item.Email }} </span>
        </template>
        <template v-slot:[`item.IsSignUp`]="{ item }">
          <v-chip
            class="ma-2"
            outlined
            color="red"
            text-color="red"
            v-if="item.IsSignUp === 'false'"
          >
            {{ item.IsSignUp }}
          </v-chip>
          <v-chip class="ma-2" outlined color="green" text-color="green" v-else>
            {{ item.IsSignUp }}
          </v-chip>
        </template>
        <template v-slot:[`item.Country`]="{ item }">
          <span class="table_style_two"> {{ item.Country }} </span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="openDetailDialog(item)"
                >
                  <v-icon color="#646464">mdi-eye</v-icon>
                  <span class="ml-4 text_style">Detail</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style action_dialog">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination
    ></v-card>
    <!-----------------Detail Dialog---------------------------->
    <v-dialog v-if="DetailDialog" v-model="DetailDialog" max-width="700">
      <v-card class="pa-6">
        <div class="d-flex justify-space-between align-center">
          <span class="heading-2"> <b> Detail Newsletters</b></span>
          <v-icon @click="DetailDialog = false">mdi-close</v-icon>
        </div>
        <div class="my-9">
          <v-row>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div><b> First Name : </b></div>
                <div class="ml-4">{{ SingleData.FirstName }}</div>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div><b> Last Name : </b></div>
                <div class="ml-4">{{ SingleData.LastName }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div><b> Email : </b></div>
                <div class="ml-4">{{ SingleData.Email }}</div>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div><b> User SignUp : </b></div>
                <div class="ml-4">No</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div><b> Language : </b></div>
                <div class="ml-4">{{ SingleData.Language.toString() }}</div>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="d-flex align-center">
                <div><b> Age : </b></div>
                <div class="ml-4">{{ SingleData.AgeRange }}</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center">
                <div><b> Subscriptions Type : </b></div>

                <div class="ml-4" v-if="SingleData.IsMember">Member News</div>
                <div class="ml-4" v-if="SingleData.IsGeneral">
                  General Newsletter
                </div>
                <div class="ml-4" v-else>None</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center">
                <div><b> How did you find us? : </b></div>
                <div class="ml-4">{{ SingleData.WhereYoufind }}</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      SingleData: [],
      DetailDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      search: "",
      tableLoader: false, // data-table true or false
      filterItem: [
        {
          text: "By Date & Date Range",
        },
        {
          text: "By Visibility",
        },
        {
          text: "Submitted By",
        },
        {
          text: "By Language ",
        },
        {
          text: "By New Comments ",
        },
      ],
      headers: [
        { text: "#", value: "indexNo", sortable: false },
        { text: "First Name", value: "FirstName" },
        { text: "Last Name", value: "LastName" },
        { text: "Email", value: "Email" },
        { text: "User SignUp", value: "IsSignUp" },
        { text: "Country", value: "Country" },

        { text: "", value: "actions", sortable: false },
      ],
      DataTable: [
        {
          firstName: "ali",
          lastName: "ali",
          email: "ali",
          country: "ali",
          usersignup: "No",
        },
        {
          firstName: "ali",
          lastName: "ali",
          email: "ali",
          country: "ali",
          usersignup: "Yes",
        },
        {
          firstName: "ali",
          lastName: "ali",
          email: "ali",
          country: "ali",
          usersignup: "Yes",
        },
        {
          firstName: "ali",
          lastName: "ali",
          email: "ali",
          country: "ali",
          usersignup: "No",
        },
        {
          firstName: "ali",
          lastName: "ali",
          email: "ali",
          country: "ali",
          usersignup: "No",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["GetNewsLetter"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetNewsLetter.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.$store.dispatch("GetALLNewsLetter");
  },
  methods: {
    openDetailDialog(item) {
      this.DetailDialog = true;
      this.SingleData = item;
    },
  },
};
</script>

<style></style>
